// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"n2-z","subtitle":"o2-z","wrapper":"p2-z","leftArrow":"q2-z","rightArrow":"r2-z"};